<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Update Your Marketing Preferences</span>'"
      :body="'<p>Select which communications you wish to receive.</p>'" />
    <StandalonePreferences />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>
<script>
  import StandalonePreferences from '@/components/StandalonePreferences'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      StandalonePreferences,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>